var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0244 23C10.6738 23 9.29068 22.9552 8 22.835C7.83167 22.8193 7.66491 22.8023 7.5 22.784M11.9756 23C16.7822 23 22 22.433 22 19.9151C22 16.5833 18.4244 15.4696 15.4056 14.449C15.1878 14.3807 14.2727 13.8333 14.2727 12.4079C15.7705 10.979 17.3611 8.64391 17.3611 6.35285C17.3611 2.83746 14.8978 1 12 1C9.10222 1 6.63889 2.83746 6.63889 6.35285C6.63889 8.64391 8.22949 10.979 9.72727 12.4079C9.72727 13.1683 9.46691 13.6788 9.19089 14",
    stroke: "#0E2483",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 5,
    stroke: "#0E2483",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.5L5 19.5L4 18.5",
    stroke: "#0E2483",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusUpdate);
export default __webpack_public_path__ + "static/media/status-update.fd6c40d8a22618b99c12b75193061ea1.svg";
export { ForwardRef as ReactComponent };